<template>
    <uw-content title="回款计划" padding="10px">

        
        <template slot="prefix">
            <el-button size="mini" :type="search.pay_state == null ? 'primary' : 'text'" @click="search.pay_state = null; TableSearch()">全部</el-button>
            <el-button size="mini" :type="search.pay_state == 1 ? 'primary' : 'text'" @click="search.pay_state = 1; TableSearch()">已回款</el-button>
            <el-button size="mini" :type="search.pay_state == 0 ? 'warning' : 'text'" @click="search.pay_state = 0; TableSearch()">未回款</el-button>
        </template>

        
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="$refs.payPlanCreate.Open()">新建回款计划</el-button>
        </template>

        
        <uw-table>

            
            <template slot="search">

                <crm-contract-select v-model="search.contract_id" @onChange="TableSearch()" />
                <users-select v-model="search.user_id" @onChange="TableSearch()" />

                
                <el-select v-model="search.invoice_state" @change="TableSearch()" placeholder="发票开具" size="mini" clearable filterable>
                    <el-option label="未开具发票" :value="0"></el-option>
                    <el-option label="已开具发票" :value="1"></el-option>
                    <el-option label="无需开具发票" :value="2"></el-option>
                </el-select>

                
                <el-select v-model="search.pay_date_plan" @change="TableSearch()" placeholder="计划回款日期" size="mini" clearable filterable>
                    <el-option label="7天内" value="-7 day"></el-option>
                    <el-option label="15天内" value="-15 day"></el-option>
                    <el-option label="30天内" value="-30 day"></el-option>
                    <el-option label="60天内" value="-60 day"></el-option>
                    <el-option label="60天后" value="+60 day"></el-option>
                </el-select>

                
                <el-select v-model="search.timeout" @change="TableSearch()" placeholder="是否超期" size="mini" clearable filterable>
                    <el-option label="未超期" :value="0"></el-option>
                    <el-option label="已超期" :value="1"></el-option>
                </el-select>
            </template>

            
            <template slot="button">
                <el-button type="primary" size="mini" @click="$refs.xTable.print()" >打印</el-button>
                <el-button type="primary" size="mini" @click="$refs.xTable.openExport()" >导出</el-button>
            </template>

            
            <template slot="data">
                <vxe-table
                    ref="xTable"
                    show-footer
                    :data="table"
                    :loading="loading"
                    :export-config="{}"
                    :print-config="{}"
                    :footer-method="tableFooterMethod"
                    :seq-config="{startIndex: page.size * (page.current - 1)}"
                    @sort-change="TableSort"
                    height="100%">

                    
                    <vxe-column width="60" type="seq" title="序号"></vxe-column>

                    
                    <vxe-column width="120" field="pay_money" title="回款金额" sortable>
                        <template #default="{ row }">
                            <el-link type="primary">
                                ￥{{ row.pay_money.toLocaleString() }}
                            </el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="120" field="pay_money_offset" title="冲销金额" sortable>
                        <template #default="{ row }">
                            <el-link type="primary">
                                ￥{{ row.pay_money_offset.toLocaleString() }}
                            </el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="200" field="customer.name" title="对应客户">
                        <template #default="{ row }">
                            <el-link type="primary">
                                {{ row.customer.name }}
                            </el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column min-width="250" field="contract.name" title="对应合同">
                        <template #default="{ row }">
                            <el-link type="primary" @click="$refs.drawerContractDetails.Open(row.contract.id)">
                                {{ row.contract.number }} - {{ row.contract.name }}
                            </el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="80" field="user.name" title="回款负责人"></vxe-column>

                    
                    <vxe-column width="80" field="pay_state" title="回款状态">
                        <template #default="{ row }">
                            <el-link v-if="row.pay_state == 0" type="warning">未回款</el-link>
                            <el-link v-if="row.pay_state == 1" type="success">已回款</el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="100" field="invoice_state" title="开具发票">
                        <template #default="{ row }">
                            <el-link v-if="row.invoice_state == 0" type="warning">未开具发票</el-link>
                            <el-link v-if="row.invoice_state == 1" type="success">已开具发票</el-link>
                            <el-link v-if="row.invoice_state == 2" type="info">无需开具发票</el-link>
                        </template>
                    </vxe-column>

                    
                    <vxe-column width="120" field="pay_date_plan" title="计划回款日期" sortable></vxe-column>

                    
                    <vxe-column width="120" field="pay_date_fact" title="实际回款日期" sortable>
                        <template #default="{ row }">
                            <el-link v-if="row.pay_state == 0 && row.pay_date_fact < 0" icon="el-icon-warning-outline" type="danger" :underline="false">超期 {{ -row.pay_date_fact }} 天</el-link>
                            <el-link v-if="row.pay_state == 0 && row.pay_date_fact > -1" icon="el-icon-bell" type="primary" :underline="false">剩余 {{ row.pay_date_fact }} 天</el-link>
                            <el-link v-if="row.pay_state == 1" icon="el-icon-date" type="info" :underline="false">{{ row.pay_date_fact }}</el-link>
                        </template>
                    </vxe-column>
  
                    <vxe-column min-width="200" field="describe" title="计划回款描述"></vxe-column>
                    <vxe-column width="80" field="create_user.name" title="创建者"></vxe-column>
                    <vxe-column width="140" title="操作" fixed="right" align="center">
                        <template #default="{ row }">
                            <el-link @click="$refs.payPlanUpdate.Open(row.id)" icon="el-icon-edit-outline" type="primary" :underline="false">编辑</el-link>
                            <el-link @click="TableDelete(row.id)" icon="el-icon-delete" type="danger" :underline="false" class="w-margin-l-10">删除</el-link>
                        </template>
                    </vxe-column>
                </vxe-table>
            </template>

            
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>
        </uw-table>

        
        <crm-contract-pay-plan-create ref="payPlanCreate" @success="TableSearch" />
        <crm-contract-pay-plan-update ref="payPlanUpdate" @success="TableSearch" />
        <crm-contract-drawer ref="drawerContractDetails" @onChange="TableSearch" />
    </uw-content>
</template>

<script>
export default {

    data () {
        return {

            loading: false,
            
            table: [],
            statistics: {},

                        page: {
                total: 0,
                size: 50,
                current: 1,
            },

                        search: {
                contract_id: null,
                user_id: null,
                pay_state: null,
                invoice_state: null,
                pay_date_plan: null,
                pay_date_fact: null,
                timeout: null,
            },

                        order: {
                method: 'desc',
                column: 'pay_date_plan'
            },
        }
    },

    mounted () {
        this.TableSearch()
    },

    methods: {
        TableSearch() {
            this.loading = true
            this.$http.post(
                '/9api/contract-pay-plan/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    statistics: true,
                    append: ['user','create_user','customer','contract']
                }
            ).then((rps) => {
                                this.page.total = rps.data.total
                this.table = rps.data.body
                this.statistics = rps.data.statistics

                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }

                                this.loading = false
            })
        },
        TableSort(column) {
            this.order.method = column.order ? column.order : this.order.method
            this.order.column = column.field
            this.TableSearch()
        },
        tableFooterMethod() {
            return [
                ['本页', '￥' + this.statistics.page?.pay_money.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), '￥' + this.statistics.page?.pay_money_offset.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })],
                ['合计', '￥' + this.statistics.all?.pay_money.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), '￥' + this.statistics.all?.pay_money_offset.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })]
            ]
        },
        TableDelete(id) {
            this.loading = true
            this.$http.post('/9api/contract-pay-plan/delete', { id: id  }).then((rps) => {
                this.TableSearch()
            })
        },
    }
}
</script>